<template>
  <v-app class="bgImage">
    <m-errorbox ref="errorBox"></m-errorbox>
    <navbar>
      <v-toolbar-title class="text-uppercase secondary--text text--darken-3">
        <span class="font-weight-light">Calibrate</span>
        <span class="font-weight-medium">Device</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </navbar>
    <v-content class="secondary--text text--darken-2">
      <v-container fluid>
        <v-row class="pt-0" v-if="factoryMode">
          <v-col>
            <v-card>
              <v-row>
                <v-col>
                  <vue-ip
                    :ip="deviceIpAddress"
                    :on-change="ipChange"
                  >
                  Device IP Address
                  </vue-ip>
                </v-col>
                <v-col>
                  <v-col>
                    <v-btn
                      @click="onTestIpAddress"
                    >Check for Connection</v-btn>
                  </v-col>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>


        <v-row>
          <v-col :lg="9">
            <v-simple-table dense>
              <thead>
                <tr>
                  <th>Parameter</th>
                  <th>Value</th>
                  <th>ADC Value</th>
                  <!--
                  <th class="text-right">Low Calibration Point</th>
                  <th class="text-right">High Calibration Point</th>
                  <th class="text-right">Low ADC Reading</th>
                  <th class="text-right">High ADC Reading</th>
                  <th>Reset Cal</th>
                  -->
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(calReading, calIndex) in calReadings"
                  :key="calReading[0]"
                  class="primary lighten-5"
                >
                  <td>{{calReading[0]}}:</td>
                  <td>{{calReading[1]}}</td>
                  <td>{{calReading[1]}}</td>
                  <!--
                  <td v-if="calRecord.copyHigh || calRecord.copyLow">
                    <span class="primary--text">Calculating...</span>
                  </td>
                  <td>{{calReadings[calIndex] && calReadings[calIndex][2]}} {{calRecord.units}}</td>
                  <td v-if="factoryMode">{{calReadings[calIndex] && calReadings[calIndex][1]}}</td>
                  <td class="text-right">
                    <a
                      href="#"
                      @click="adjustCalPoint = {'point':'Low', 'index':calIndex}; calPointEditValue = calRecord.valLow"
                      style="text-decoration:none;"
                    >
                      <v-icon color="primary">mdi-lead-pencil</v-icon>
                    </a>
                    <span
                      :class="{'font-weight-black':calRecord.lowUpdated}"
                    >{{ calRecord.valLow }} {{calRecord.units}}</span>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <a
                          href="#"
                          @click="onCopyCalValueLow(calIndex)"
                          style="text-decoration:none;"
                          v-on="on"
                        >
                          <v-icon color="primary">mdi-transfer-left</v-icon>
                        </a>
                      </template>
                      <span>Apply {{calRecord.name}} Low Calibration Point</span>
                    </v-tooltip>
                  </td>
                  <td class="text-right">
                    <a
                      href="#"
                      @click="adjustCalPoint = {'point':'High', 'index':calIndex}; calPointEditValue = calRecord.valHigh;"
                      style="text-decoration:none;"
                    >
                      <v-icon color="primary">mdi-lead-pencil</v-icon>
                    </a>
                    <span
                      :class="{'font-weight-black':calRecord.highUpdated}"
                    >{{ calRecord.valHigh }} {{calRecord.units}}</span>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <a
                          href="#"
                          @click="onCopyCalValueHigh(calIndex)"
                          style="text-decoration:none;"
                          v-on="on"
                        >
                          <v-icon color="primary">mdi-transfer-left</v-icon>
                        </a>
                      </template>
                      <span>Apply {{calRecord.name}} High Calibration Point</span>
                    </v-tooltip>
                  </td>
                  <td v-if="factoryMode" class="text-right">{{ calRecord.adcLow }}</td>
                  <td v-if="factoryMode" class="text-right">{{ calRecord.adcHigh }}</td>
                  <td v-if="factoryMode" class="text-center">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <a
                          href="#"
                          @click="onSetCalRecord(calRecord, calIndex)"
                          style="text-decoration:none;"
                          v-on="on"
                        >
                          <v-icon color="error">mdi-refresh</v-icon>
                        </a>
                      </template>
                      <span>Reset {{calRecord.name}} cablibration values to factory default.</span>
                    </v-tooltip>
                  </td>
                  -->
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="3">
            <v-btn @click="onSaveCalValues">Save Changed Calibration Values</v-btn>
          </v-col>
          <v-col v-if="factoryMode" lg="3">
            <v-btn @click="onSetCalRecords" color="error">Set All Calibration to Default</v-btn>
          </v-col>
          <v-col v-if="factoryMode" lg="3">
            <v-btn @click="onSetToken" color="error">Set Device Token</v-btn>
          </v-col>
        </v-row>
      </v-container>

      <v-dialog :value="adjustCalPoint" width="500">
        <v-card>
          <v-card-title class="text-center pa-4 primary secondary--text text--darken-3">
            <v-row justify="center">
              <span class="text-uppercase text-center font-weight-light">
                <span v-if="adjustCalPoint" class="font-weight-medium">
                  Set
                  <b>
                    <u>{{calRecords[adjustCalPoint.index].name}} {{adjustCalPoint.point}}</u>
                  </b> Calibration Point
                </span>
              </span>
            </v-row>
          </v-card-title>
          <v-form @submit.prevent="calPointAdjustHandler">
            <v-card-actions class="mt-4 mb-0 pb-0 text-center">
              <v-text-field
                label="Value"
                type="number"
                v-model="calPointEditValue"
                ref="limitFormInput"
                @focus="$event.target.select()"
              ></v-text-field>
            </v-card-actions>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="secondary--text text--darken-3" type="submit">Ok</v-btn>
              <v-btn @click="adjustCalPoint = null;" type="button">Cancel</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-content>
  </v-app>
</template>

<script>
import usbRequest from "../mixins/usb-request";
import apiEndpoints from "../mixins/api-endpoints";
import apiRequest from "../mixins/api-request";
export default {
  mixins: [usbRequest, apiEndpoints, apiRequest],
  data() {
    return {
      calRecords: [],
      calReadings: [],
      factoryMode: false,
      deviceIpAddress:"10.0.0.7",
      factoryConfig: {
        modemInstalled: null,
        allowedMainsChannels: 0,
        allowedBatteryChannels: 0
      },
      adjustCalPoint: null,
      calPointEditValue: 0
    };
  },
  async mounted() {
    //this.usbRequest('device', this.$route.params.id).then(r=>console.log(r));
    this.factoryMode = this.userData.permissions.includes("create_devices");
    //this.factoryMode = true;
    //this.factoryMode = false;
    this.pollDevice();
  },
  methods: {
    showError(message) {
      this.$refs.errorBox.showError(message);
    },
    ipChange(arg1, arg2){
      console.log("IP CHANGE: ", arg1, arg2);
    },
    onTestIpAddress(arg1, arg2){
      this.deviceGetToken().then((tok)=>{
        console.log("TOKEN:", tok);
      });
    },
    scaleReading(index) {
      var calRecord = this.calRecords[index];
      if (calRecord !== undefined) {
        // the adc reading
        let temp = parseInt(this.calReadings[index][1]);

        if (calRecord.copyLow) {
          calRecord.adcLow = temp;
          calRecord.copyLow = false;
          calRecord.lowUpdated = true;
        }

        if (calRecord.copyHigh) {
          calRecord.adcHigh = temp;
          calRecord.copyHigh = false;
          calRecord.highUpdated = true;
        }

        let precision = parseInt(calRecord.precision);

        let valLow = parseFloat(calRecord.valLow) * Math.pow(10, precision); //(already scaled by usb-request.js)
        let valHigh = parseFloat(calRecord.valHigh) * Math.pow(10, precision); //(already scaled by usb-request.js)
        let adcLow = parseInt(calRecord.adcLow);
        let adcHigh = parseInt(calRecord.adcHigh);

        // calculate the divisor
        let valRange = valHigh - valLow;
        let adcRange = adcHigh - adcLow;
        let divisor = 1024;
        if (valRange != 0) {
          divisor = (adcRange << 10) / valRange;
        }
        divisor >>= 0;

        temp -= adcLow;
        temp <<= 10;

        // round the reading up.
        temp += (divisor / 2) >> 0;

        temp /= divisor;
        temp >>= 0;

        temp += valLow;
        temp /= Math.pow(10, precision);
        this.calReadings[index][2] = temp.toFixed(precision);
      }
    },

    async pollDevice() {
      // only re-run the polling loop whilst we are on this route.
      this.calReadings = await this.ipGetCalReadings();
      console.log(this.calReadings);
      if(this.calReadings){

        this.calReadings.forEach((statItem, index) => {
          this.scaleReading(index);
        });
        if (this.$router.currentRoute.name == "calibrate") {
          setTimeout(this.pollDevice, 500);
        }

      } else {

        // we didn't get any readings so we probably aren't connected,
        // so reduce poll rate to 5 seconds.
        if (this.$router.currentRoute.name == "calibrate") {
          setTimeout(this.pollDevice, 5000);
        }

      }
    },
    async onSaveCalValues() {
      let transactionOk = true;
      this.calRecords.forEach(async (record, index) => {
        if (record.highUpdated || record.lowUpdated) {
          transactionOk =
            transactionOk &&
            (await this.usbSaveCalValue(
              index,
              record.adcLow,
              record.adcHigh
            )) !== false;
          console.log(transactionOk);
        }
      });

      if (transactionOk) {
        this.calRecords = await this.usbGetCalRecords();
      }
    },
    async onSetCalRecord(record, index) {
      console.log("onSetCalRecord should be unused.")
    },
    async setCalRecord(record, index) {
      let defaultValues = [
        // NAMES                 valLow, valHigh, adcLow, adcHigh
        [["VA", "VB", "VC"], 2200, 2550, 7988, 9261],
        [["VE"], 300, 1200, 10260, 66054],
        [["IA", "IB", "IC"], 1000, 4000, 11312, 58125],
        //[["IN"], 500, 2000, 11312, 58125],
        [["IN"], 1000, 4000, 11312, 58125],
        [["PAA", "PAB", "PAC"], 0, 314, 26564, -5124],
        [["AFA", "AFB", "AFC"], 50, 500, 54, 545],
        [["FREQ"], 4000, 5000, 25000, 20000]
      ];

      let values = defaultValues.find(elem => elem[0].includes(record.name));
      if (values) {
        console.log(record.name + " Matches");
        return await this.usbSetCalRecord(
          index,
          values[1],
          values[2],
          values[3],
          values[4]
        );
      }
    },

    async onSetCalRecords() {
      /*
      let transactionOk = true;

      this.calRecords.forEach(async (record, index) => {
        transactionOk =
          transactionOk && (await this.setCalRecord(record, index)) !== false;
      });

      if (transactionOk) {
        console.log("Cal Set Ok!");
        this.onGetCalRecords();
      } else {
        console.log("TRANSACTION ERROR");
      }
      */
    },

    onCopyCalValueHigh(index) {
      this.calRecords[index].copyHigh = true;
    },
    onCopyCalValueLow(index) {
      this.calRecords[index].copyLow = true;
    },
    async onSetToken() {
      let response = await this.apiRequest(
        this.apiEndpoints.createDevice,
        null,
        { old_token: this.$route.params.id }
      );
      console.log(response);
      if (
        this.checkStatus(
          response,
          "Error getting token and/or secret from server"
        )
      ) {
        let token = response.body.data.device_token;
        let secret = response.body.data.device_secret;

        let usbDeviceToken = await this.usbGetToken(token);
        if (usbDeviceToken !== token) {
          console.error(
            "New token was",
            token,
            "But device responded with",
            usbDeviceToken
          );
          this.showError("Error setting new device token.");
          return;
        }

        let usbDeviceSecret = await this.usbSetSecret(secret);
        if (usbDeviceSecret !== secret) {
          console.error(
            "New secret was",
            secret,
            "But device responded with",
            usbDeviceSecret
          );
          this.showError("Error setting new device secret.");
          return;
        }

        alert("Device secret and token successfully set.");
        this.$router.replace("/calibrate/" + usbDeviceToken);
      }
    },
    async onSetFactoryConfig(evt) {
      Vue.set(
        this,
        "factoryConfig",
        await this.usbSetFactoryConfig(this.factoryConfig)
      );
      console.log(this.factoryConfig);
    },
    calPointAdjustHandler() {
      if (this.adjustCalPoint) {
        let calRecord = this.calRecords[this.adjustCalPoint.index];
        calRecord["val" + this.adjustCalPoint.point] = parseFloat(this.calPointEditValue);
        this.usbSetCalRecord(
          this.adjustCalPoint.index,
          calRecord.valLow * Math.pow(10, calRecord.precision), //valLow
          calRecord.valHigh * Math.pow(10, calRecord.precision), //valHigh
          calRecord.adcLow, //adcLow
          calRecord.adcHigh //adcHigh
        ).then((result)=>{
          this.adjustCalPoint = null;
          this.usbGetCalRecords().then((result)=>{
            this.calRecords = result;
          });
        });
      }
    }
  },
  computed: {
    allowedMainsChannels: {
      // getter
      get: function() {
        var result = [];
        for (var i = 0; i < this.calRecords.length; i++) {
          result.push(this.factoryConfig.allowedMainsChannels & (1 << i));
        }
        return result;
      },
      // setter
      set: function(newValue) {
        this.factoryConfig.allowedMainsChannels = newValue.reduce(
          (total, num) => total + num
        );
      }
    },
    allowedBatteryChannels: {
      // getter
      get: function() {
        var result = [];
        for (var i = 0; i < this.calRecords.length; i++) {
          result.push(this.factoryConfig.allowedBatteryChannels & (1 << i));
        }
        return result;
      },
      // setter
      set: function(newValue) {
        this.factoryConfig.allowedBatteryChannels = newValue.reduce(
          (total, num) => total + num
        );
      }
    }
  }
};
</script>
